import { getCompanies, getCompany } from 'services/api/companies';
import config from '../../config';
import { useAxios } from '../useAxios';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

export const GET_COMPANIES_QUERY_ID = 'companies/list';

export function useGetCompany(companyId: string) {
  const axios = useAxios();

  return useQuery([GET_COMPANIES_QUERY_ID, companyId], () => getCompany(axios, companyId), {
    enabled: !!companyId
  });
}

export function useGetCompanies(limit = config.service.QUERY_DEFAULT_LIMIT, search = '') {
  const axios = useAxios();

  return useInfiniteQuery(
    [GET_COMPANIES_QUERY_ID, search],
    ({ pageParam }) => getCompanies(axios, pageParam, limit, search),
    {
      getNextPageParam: (lastData, pages) => pages.length
    }
  );
}
